import getBackendStatus from './getBackendStatus';

// eslint-disable-next-line import/prefer-default-export
export { getBackendStatus };